__turbopack_context__.v({
  "container": "trancheSizeCell-module-scss-module__QqRgYq__container",
});
